import React, { useState , useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import { useDispatch } from 'react-redux';
import { Get_Add_On_Details, Purchase_Add_On } from '../../../slices/thunks';
import { useSelector } from 'react-redux';


const Add_Token_Modal = ({ Next_Bill_Date }) => {
const dispatch = useDispatch()
const { Add_On_Plan_Details } = useSelector((state) => state.Plans )

  const [modal_standard, setmodal_standard] = useState(false);
  const [price, setprice] = useState(null)
    function tog_standard_token() {
        setmodal_standard(!modal_standard);
    }
// Pills Tabs
const [pillsTab, setpillsTab] = useState("1");
const pillsToggle = (tab , price) => {
    if (pillsTab !== tab) {
        setpillsTab(tab);
    }

    setprice(price);
};


useEffect(() => {
 

    dispatch(Get_Add_On_Details())
    

}, [])

useEffect(() => {
   setprice(Add_On_Plan_Details[0]?.Price)
}, [Add_On_Plan_Details])

const onClick_Purchase_token = () =>{
    // console.log("Purchase token")
  
    dispatch(Purchase_Add_On({ price:parseInt(price) , type_:'add_on' }))
}

  
    
  return (
    <>
    <Button onClick={() => tog_standard_token()}>ADD TOKEN</Button>
      
      {/* Default Modal */}
        <Modal id="myModal"
            isOpen={modal_standard}
            toggle={() => {
              tog_standard_token();
            }}
        >
            <ModalHeader className="modal-title border-bottom" style={{ paddingBottom : '10px !important'}}
                id="myModalLabel" toggle={() => {
                  tog_standard_token();
                }}> 
                Add More Token
            </ModalHeader>
           
         <ModalBody>
                <div className='add_more_token'>
                
                    <Row>
                          <Col md={12}>{

                          }
                             <Nav pills className="nav-secondary mb-3 add_token_nav">
                                {
                                    Add_On_Plan_Details?.map((data,index)=>{
                                         return    <NavItem>
                                         <NavLink style={{ cursor: "pointer" }} className={classnames({ active: pillsTab == index+1, })} onClick={() => { pillsToggle(`${index+1}`,data.Price); }} >
                                         ${data.Price}
                                         </NavLink>
                                     </NavItem>
                                    })
                                }
                              
                            </Nav>
                            <TabContent activeTab={pillsTab} className="text-muted add_token
                            _modal">
                                {
                                    Add_On_Plan_Details?.map((data, index)=>{
                                        return (
                                          <TabPane tabId={`${index+1}`} id="home-1">
                                            <div className="d-flex jc">
                                              <div className="">
                                                <i className="ri-checkbox-circle-fill text-success"></i>
                                              </div>
                                              <div className="ms-2">
                                                <b>{data.Tokens} Token</b>
                                              </div>
                                            </div>
                                            <p className='text-muted tokenex_detail'>Tokens will be expired on {Next_Bill_Date}</p>
                                          </TabPane>
                                        );
                                    })
                                }
                                        {/* 
                                        <TabPane tabId="1" id="home-1">
                                            <div className="d-flex jc" >
                                                <div className="">
                                                    <i className="ri-checkbox-circle-fill text-success"></i>
                                                </div>
                                                <div className="ms-2">
                                                    <b>100000 Token</b>
                                                </div>
                                            </div>
                                        </TabPane>
                                         */}

                                        {/* <TabPane tabId="2" id="profile-1">
                                            <div className="d-flex jc">
                                                <div className="">
                                                    <i className="ri-checkbox-circle-fill text-success"></i>
                                                </div>
                                                <div className="ms-2">
                                                <b>10000000 Token</b>
                                                </div>
                                            </div>
                                        </TabPane> */}

                                        {/* <TabPane tabId="3" id="messages-1" >
                                            <div className="d-flex">
                                                <div className="flex-shrink-0">
                                                    <i className="ri-checkbox-circle-fill text-success"></i>
                                                </div>
                                                <div className="flex-grow-1 ms-2">
                                                    Each design is a new, unique piece of art birthed into this world, and while you have the opportunity to be creative and make your own style choices.
                                                </div>
                                            </div>
                                            <div className="d-flex mt-2">
                                                <div className="flex-shrink-0">
                                                    <i className="ri-checkbox-circle-fill text-success"></i>
                                                </div>
                                                <div className="flex-grow-1 ms-2">
                                                    For that very reason, I went on a quest and spoke to many different professional graphic designers and asked them what graphic design tips they live.
                                                </div>
                                            </div>
                                        </TabPane>

                                        <TabPane tabId="4" id="settings-1">
                                            <div className="d-flex mt-2">
                                                <div className="flex-shrink-0">
                                                    <i className="ri-checkbox-circle-fill text-success"></i>
                                                </div>
                                                <div className="flex-grow-1 ms-2">
                                                    For that very reason, I went on a quest and spoke to many different professional graphic designers and asked them what graphic design tips they live.
                                                </div>
                                            </div>
                                            <div className="d-flex mt-2">
                                                <div className="flex-shrink-0">
                                                    <i className="ri-checkbox-circle-fill text-success"></i>
                                                </div>
                                                <div className="flex-grow-1 ms-2">
                                                    After gathering lots of different opinions and graphic design basics, I came up with a list of 30 graphic design tips that you can start implementing.
                                                </div>
                                            </div>
                                        </TabPane> */}
                                    </TabContent>
                              
                            </Col>
                          
                            
                        </Row>    
                        
                    </div>
                </ModalBody>
                <div className="modal-footer"> 
                    <Button                   
                        color="secondary"
                        onClick={onClick_Purchase_token}
                    >
                       PURCHASE TOKEN
                    </Button>
                </div>
        </Modal>
    </>
  )
}

export default Add_Token_Modal